export default __webpack_public_path__ + "static/media/tr.0eb94b06.svg";